import GoogleMapsApiLoader from 'google-maps-api-loader';

class Map {
  constructor() {
    this.settings = {
      mapSelector: '.map',
      tabsSelector: '.nav-pills a',
    };
    this.mapOptions = {
      zoom: 5,
      scrollwheel: false,
      disableDefaultUI: false,
    };
  }

  init() {
    this.initTabSListener();
    GoogleMapsApiLoader({
      libraries: ['places'],
      apiKey: 'AIzaSyDv03bPAYlNRkunl-h_dA9K9AU8u9rsDvE',
    }).then(() => {
        $(this.settings.mapSelector).map((index, element) => {
          const $element = $(element);
          this.createMap($element);
          return element;
        });
      },
      (err) => {
        console.error(err);
      });
  }

  initTabSListener() {
    const $tab = $(this.settings.tabsSelector);
    $tab.on({
      click() {
        setTimeout(() => {
          const evt = window.document.createEvent('UIEvents');
          evt.initUIEvent('resize', true, false, window, 0);
          window.dispatchEvent(evt);
        }, 200);
      },
    });
  }

  createMap($el) {
    const $markers = JSON.parse($el.attr('data-markers').replace(/'/g, '"'));
    const mapPosition = { lat: parseFloat($el.attr('data-lat')), lng: parseFloat($el.attr('data-lng')) };
    const zoom = $el.attr('data-zoom') ? $el.attr('data-zoom') : false;
    if (zoom) {
      this.mapOptions.zoom = parseInt(zoom, 10);
    }
    const args = this.mapOptions;
    const { google } = window;
    args.center = mapPosition;
    args.mapTypeId = google.maps.MapTypeId.ROADMAP;
    const map = new google.maps.Map($el[0], args);
    map.markers = [];
    if ($markers) {
      $markers.map((marker) => {
        this.addMapMarker(marker, map);
        return marker;
      });
    }
    const center = mapPosition;
    google.maps.event.addDomListener(window, 'resize', () => {
      google.maps.event.trigger(map, 'resize');
      map.setCenter(center);
    });
    return map;
  }

  static addInfoBox(marker) {
    const { image } = marker;
    const infoBoxContentString = `
    <div class="content">
      <div class="image" style="background-image: url(${image}"></div>
      <h4 class="title"><a href="${marker.url}" target="_blank">${marker.name}</a></h4>
    </div>`;
    const { google } = window;
    return new google.maps.InfoWindow({
      content: infoBoxContentString,
    });
  }

  addMapMarker(data, map) {
    const { google } = window;
    const infoBox = this.constructor.addInfoBox(data);
    const latlng = { lat: parseFloat(data.lat), lng: parseFloat(data.lng) };
    const icon = {
      url: `${window.assetsUrl}/assets/images/location-icon.svg`,
      size: new google.maps.Size(32, 36),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(15, 36),
      scaledSize: new google.maps.Size(96, 96),
    };
    const marker = new google.maps.Marker({
      position: latlng,
      animation: google.maps.Animation.DROP,
      icon,
    });
    marker.addListener('click', () => {
      infoBox.open(map, marker);
    });
    google.maps.event.addDomListener(window, 'resize', () => {
      infoBox.close();
    });
    marker.setMap(map);
    map.markers.push(marker);
  }
}

export default Map;
